import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export const BarChart = ({ width, height, data }) => {
  const [error, setError] = useState(null);
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    try {
      const parsedData = JSON.parse(JSON.stringify(data)); // clone data safely

      const formattedData = {
        labels: parsedData.labels,
        datasets: parsedData.values.map((dataset) => ({
          ...dataset,
          // backgroundColor: dataset.backgroundColor || "rgba(54, 162, 235, 0.5)",
          // borderColor: dataset.borderColor || "rgba(54, 162, 235, 1)",
          borderWidth: 1,
        })),
      };

      setChartData(formattedData);
      setError(null);
    } catch (err) {
      console.error("Failed to render chart:", err);
      setError("Something went wrong while generating the chart.");
    }
  }, [data]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        grid: {
          display: true,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "#f1f1f1",
        },
      },
    },
  };

  return (
    <div style={{ width, height }}>
      {error ? (
        <div style={{ color: "red", padding: "10px" }}>{error + " Use Another favorite prompt to generate"}</div>
      ) : (
        chartData && <Bar data={chartData} options={options} />
      )}
    </div>
  );
};

